import { render, staticRenderFns } from "./slippage-tenant.vue?vue&type=template&id=5e75756a&scoped=true&"
import script from "./slippage-tenant.vue?vue&type=script&lang=js&"
export * from "./slippage-tenant.vue?vue&type=script&lang=js&"
import style0 from "./slippage-tenant.vue?vue&type=style&index=0&id=5e75756a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e75756a",
  null
  
)

export default component.exports